<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Course Authority Levels </span>
    </v-row><br />
    <v-card class="card">
    <center class="heading"><h3>Course Authority Levels</h3></center>
     <v-card-text>
    <template v-if="auth_level_list!=null">
      <span v-if="auth_level_list.length>0" style="color:red">*Note: Only one level should be marked as IsLast.</span>  
      <v-row justify="center">
        <v-col md="12" sm="12">
          <v-data-table :headers="headers" :items="auth_level_list" class="elevation-1 nowrap" :search="search"  >
            <template v-slot:top>
              <v-toolbar flat color="white">

                <v-spacer></v-spacer>
                <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mb-2 button" v-on="on" >New Authority Levels</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="heading">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field dense v-model.trim="editedItem.name"
                            :readonly="editedIndex==-1?false:true"
                            persistent-hint
                            :hint="editedIndex==-1?'Authority level name':'Can not edit name!!!'"
                             label="Name"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete dense
                                v-model="editedItem.auth_operation"
                                :items="auth_operation_list"
                                label="Course Authority Operation"
                                single-line
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                         <v-row>
                          <v-col cols="12" sm="4" md="4">
                             <v-autocomplete dense
                                v-model="editedItem.level_no"
                                :items="level_nos"
                                label="Level no"
                                single-line
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-checkbox v-model="editedItem.islast" class="mx-2" label="IsLast?"></v-checkbox>
                          </v-col>
                            <v-col cols="12" sm="4" md="4">
                            <v-checkbox v-model="editedItem.isactive" class="mx-2" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>                       
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn rounded class="button-cancel" text @click="close">Cancel</v-btn>
                      <v-btn rounded class="button" :loading="save_btn_load" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.isactive="{ item }">
              <v-icon
                v-if="item.isactive==true"
                color="success"
                class="mr-2"
              >mdi-check-circle-outline</v-icon>
              <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
            </template>
             <template v-slot:item.islast="{ item }">
              <v-icon
                v-if="item.islast==true"
                color="success"
                class="mr-2"
              >mdi-check-circle-outline</v-icon>
              <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <span v-if="item.crslevel_id == 'false'">
                <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                          <!-- <v-btn outlined rounded class="ma-2" color="gray" v-bind="attrs" v-on="on"> Delete -->
                            <v-icon color="gray" v-bind="attrs" v-on="on">mdi-delete-circle</v-icon>
                             <!-- </v-btn> -->
                      </template>
                      <span>
                          This Level Assigned Can't Delete !!!
                      </span>
                  </v-tooltip>
              </span>
              <span v-else>
                <v-icon  color="red" class="mr-2" @click="deletedialog(item.id)">mdi-delete-circle</v-icon>
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog_delete" persistent max-width="400px">
            <v-card>
                <v-container>
                    <input type="hidden" v-model="deleteItem.delete_id" />
                    <h3><strong>Are you sure you want delete this authority level?</strong></h3>
                    <v-row justify="center">
                    <v-btn class="button-cancel mr-2" @click="dialog_delete = false">No</v-btn>
                    <v-btn class="button" @click="deletecrslevel()">Yes</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </template>
    </v-card-text>
    </v-card>
  </div>
</template>


<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  data: () => ({
    arr:[],
    snackbar_msg: "",
    snackbar: false,
    search:'',
    color: "",
    org: null,
    dialog: false,
    save_btn_load: false,
    dialog_delete: false,
    //
    auth_level_list: null,
    auth_operation_list:null,
    level_nos:[1,2,3,4,5,6,7,8,9],
    headers: [
      { text: "Level No", value: "level_no" },
       { text: "Name", value: "name" },
      { text: "Is Last", value: "islast" },
      { text: "Operation", value: "auth_operation" },
      { text: "Activate?", value: "isactive" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      level_no:1,
      islast:false,
      auth_operation:null,
      isactive: true
    },
    defaultItem: {
      name: "",
      level_no:1,
      islast:false,
      auth_operation:null,
      isactive: true
    },
     deleteItem: {
                    delete_id: "",
                },
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
        //console.log(item)
      this.editedIndex = this.auth_level_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.level_nos.push(this.editedItem.level_no)
      this.dialog = true;
    },
     deletedialog(item) {
               // alert(item)
                this.dialog_delete = true;
                this.deleteItem.delete_id = item;
            },
    deletecrslevel()
    {
      //alert("in delete")
       let formData = new FormData();
                formData.append("crslevel", this.deleteItem.delete_id);
                axios
                    .post("/adminMaster/deletecrslevel", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Deleted Successfully.");
                            this.dialog_delete = false;
                             this.onload()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                       //  alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.close();
                    });

    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.editedItem.auth_operation = this.auth_operation_list[0]
        this.editedItem.level_no = this.level_nos[0]
      }, 300);
    },
    save() {
      if (this.editedItem.name == "" || this.editedItem.name == null || this.editedItem.auth_operation==null||this.editedItem.level_no==null) {
        this.showSnackbar("#b71c1c", "Please enter required details");
        return;
      }
      if (this.editedIndex > -1) {

console.log(this.arr)

        this.save_btn_load = true;
        axios
          .post("/adminMaster/editCourseAuthorityLevels", this.editedItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Course Authority Level updated successfully...");
              this.auth_level_list = res.data.auth_level_list;
              this.getLevelNo()

              //Object.assign(this.auth_level_list[this.editedIndex], this.editedItem);

            } else {
              this.showSnackbar("#b71c1c", "Cannot Edit, May be due to duplication.");
            }
          })
          .catch(error => {
            console.log(error,'error');
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
          });
      } else {
        this.save_btn_load = true;
        axios
          .post("/adminMaster/saveCourseAuthorityLevels", this.editedItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Course Authority Level added successfully...");
              this.auth_level_list = res.data.auth_level_list;
              this.getLevelNo()
            } else {
              this.showSnackbar("#b71c1c", "Course Authority Level already present!!!");
            }
          })
          .catch(error => {

            this.showSnackbar("#b71c1c", "Something Went Wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
            this.editedItem.name=null
            this.editedItem.auth_operation=null
            this.editedItem.level_no=null
          });
      }
      this.close();
    },
    getLevelNo(){
        //list.splice( list.indexOf('foo'), 1 );
        let list = this.auth_level_list
        this.level_nos=[1,2,3,4,5,6,7,8,9]
        for(var i=0;i<list.length;i++ ){
           this.level_nos.splice(this.level_nos.indexOf(list[i].level_no),1)
        }
    },
    onload(){
      axios
      .post("/adminMaster/courseAuthorityLevels")
      .then(res => {
        this.org = res.data.org;
        this.auth_operation_list = res.data.auth_operation_list;
        this.auth_level_list = res.data.auth_level_list;
        this.editedItem.auth_operation = this.auth_operation_list[0]
        this.getLevelNo()
        // this.showSnackbar("#4CAF50","Success")
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something Went Wrong!!!");
      })
      .finally(() => {});
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Course Authority Level" : "Edit Course Authority Level ";
    }
  },
  mounted() {
    this.onload()
  }
};
</script>

<style scoped>

.elevation-1 /deep/ 
  thead {
  background: lightgray !important;
}
.elevation-1 /deep/ 
  table {
  border: 1px solid lightgray;
}

</style>